import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

import { SingleAssignmentFragment } from '../../../../generated/graphql_offer';
import { gridLayoutContainer, gridLayoutItem } from '../../../styleUtility/gridLayout';
import _CompleteButton from './CompleteButton';

interface Props {
  assignment: SingleAssignmentFragment;
  reload: () => Promise<unknown>;
  className?: string;
}

const CompleteForm = ({ assignment, reload, className }: ClassAttributes<HTMLElement> & Props) => (
  <Root className={className}>
    {assignment.status == 'ASSIGNED' && assignment.assignedStatus == 'SUBMITTED' ? (
      <CompleteButton assignment={assignment} reload={reload} />
    ) : null}
  </Root>
);

const Root = styled('div')(
  gridLayoutContainer({
    columns: ['1fr'],
    rows: ['auto', 'auto'],
    areas: [['headings'], ['reviewButton']],
  }),
  {
    textAlign: 'center',
  },
);

const CompleteButton = styled(_CompleteButton)(gridLayoutItem('reviewButton'));

export default CompleteForm;
